/**
 * Main JavaScript File
 */

import '../scss/main.scss';

// Template Parts
import { header } from './template-parts/header/header'

// ACF Blocks
import { initTestimonialsSlider } from './template-parts/blocks/testimonials-slider'
import { initHeroBannerSlider } from './template-parts/blocks/hero-banner-slider'
import { initLogosSlider } from './template-parts/blocks/logos-slider'

import { videoBlock, videoOrganizations } from './template-parts/blocks/video'
import { initRotatorHero } from './template-parts/blocks/rotator-hero'
import { insightsLoadMore } from './template-parts/blocks/insights-loadmore'

// Components
import { investorGate } from './components/investor-gate'
import { appearence } from './components/animations/appearence'
import { filters } from './components/filters'
import { initFormNumberSliderHooks } from './components/forms/form-number-slider'

// Utils
import 'bootstrap/js/src/collapse'

// Components
investorGate()
appearence()

if ( document.querySelector( '[data-action="filters"]' ) ) {
	filters()
}

// Template Parts
header()

// ACF Blocks
initTestimonialsSlider()
initHeroBannerSlider()
initLogosSlider()
videoBlock()
videoOrganizations()
initFormNumberSliderHooks()
initRotatorHero()
insightsLoadMore()
